<template>
  <div id="home" class="content container">
    <img src="/assets/images/logo-small.png">
    <p class="img-wrap">The Garage Rats Car Club was founded in 2008 by Rich Munoz and brothers Kevin &amp; Bill Fletcher. While working on Rich’s Camaro there was a discussion about how much fun it would be to get all the car guys in Erie together and form a club.</p>
    <p class="img-wrap">They came up with a plan to get in touch with all the guys that still had their hot rods and hold a car show, but the club still needed a name. Kevin, always liking the RAT FINK and talking about all of the old garages in town, inspired the name GARAGE
      RATS. Being an avid cartoon artist, Kevin also created the well-known Garage Rats logo.</p>
    <p>With a plan, a name and a logo all established, it was finally time to hold the first car show, which took place in Longmont CO. on May 17th, 2008.</p>
    <p>With the success of the first show, the club worked with the Erie Chamber of Commerce to hold an annual car show in conjunction with the Erie Town Fair. In 2009 the first Garage Rats/Erie Town Fair car show was held with 55 entries (some from as far
      away as Greeley and Denver), all prominently placed in the center of the day's activities.</p>
    <p>We are still a small club, but with big horse power. We enjoy cooking breakfast &amp; lunch as well as providing great music at our shows.</p>
    <p>In addition to hosting our own car shows, we also enjoy attending other shows and shooting the bull with other car enthusiasts.</p>
    <!-- <p>Check out our events page for the next Garage Rats Car Show!</p> -->
  </div>
</template>

<script>
  export default {
    name: 'HomeView'
  }
</script>

<style scoped>
  #home img {
    float: right;
    margin-left: 10px;
  }
  
  #home .img-wrap {
    text-align: justify;
  }
</style>
